// Custom Hero Fade-in Animation
document.addEventListener('DOMContentLoaded', function() {
  const heroSection = document.querySelector('.c-hero-section');
  
  if (!heroSection) return;
  
  // Function to add fade-in class
  function addFadeInClass() {
    heroSection.classList.add('fade-in');
  }
  
  // Check if element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  // Intersection Observer for better performance
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          addFadeInClass();
          observer.unobserve(entry.target); // Only trigger once
        }
      });
    }, {
      threshold: 0.1, // Trigger when 10% of the element is visible
      rootMargin: '0px 0px -50px 0px' // Trigger slightly before element comes into view
    });
    
    observer.observe(heroSection);
  } else {
    // Fallback for older browsers
    function checkScroll() {
      if (isInViewport(heroSection)) {
        addFadeInClass();
        window.removeEventListener('scroll', checkScroll);
      }
    }
    
    // Check immediately in case element is already in view
    if (isInViewport(heroSection)) {
      addFadeInClass();
    } else {
      window.addEventListener('scroll', checkScroll);
    }
  }
  
  // Also trigger on page load with a small delay for better UX
  setTimeout(() => {
    if (heroSection.getBoundingClientRect().top < window.innerHeight) {
      addFadeInClass();
    }
  }, 100);
});
